import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MessagesPanelService {
  private activeMessagesSubject = new Subject<void>();
  activeMessages$ = this.activeMessagesSubject
    .pipe(
      switchMap(() => this.getActiveMessages()),
    );

  refreshActiveMessages = () => this.activeMessagesSubject.next();

  constructor(
    private http: HttpClient,
  ) { }

  addMessage(message: string) {
    return this.http.post<void>('/api/banner-messages/add-message', { message });
  }

  readMessage(messageId: number) {
    return this.http.post<void>('/api/banner-messages/read-message', { messageId });
  }

  get(): Observable<any> {
    return this.http.get('/api/banner-messages/get-messages');
  }

  getActiveMessages(): Observable<any> {
    return this.http.get('/api/banner-messages/get-active-messages');
  }

  obsolete(messageId: number, isObsolete: boolean): Observable<any> {
    return this.http.post('/api/banner-messages/obsolete-message', { messageId, isObsolete });
  }

  delete(messageIds: Array<number>): Observable<any> {
    return this.http.post('/api/banner-messages/delete-messages', { messageIds });
  }
}
